import { createFileRoute, Outlet } from '@tanstack/react-router'
import type { WeddingThemeColors } from '@wedding-tech/ui/theme'
import { WeddingThemeProvider } from '@wedding-tech/ui/wedding-theme-provider'

import {
  SettingsProvider,
  useSettingsContext,
} from '@/contexts/SettingsContext'

export const Route = createFileRoute('/e/$eventId')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <SettingsProvider>
      <ThemedOutlet />
    </SettingsProvider>
  )
}

function ThemedOutlet() {
  const { settings } = useSettingsContext()
  const theme = (settings as { theme?: WeddingThemeColors } | undefined)?.theme

  return (
    <WeddingThemeProvider
      theme={theme}
      className="contents"
    >
      <Outlet />
    </WeddingThemeProvider>
  )
}
